
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.479 12.418a.25.25 0 0 1 0 .353l-.707.707a.25.25 0 0 1-.354 0L10 11.06l-2.418 2.418a.249.249 0 0 1-.353 0l-.708-.707a.25.25 0 0 1 0-.353L8.94 10 6.522 7.582a.25.25 0 0 1 0-.354l.707-.707a.25.25 0 0 1 .353 0L10 8.94l2.418-2.418a.252.252 0 0 1 .354 0l.707.707a.252.252 0 0 1 0 .354L11.06 10l2.418 2.418zM10 1a9 9 0 1 0 .001 18.001A9 9 0 0 0 10 1z"}})])
          )
        }
      }
    